import React from "react";
import { Wrapper } from "./styled";

const Header = ({ content }) => {
  return <Wrapper>{content}</Wrapper>;
};

export default Header;
